import React, { useMemo } from 'react'
import MirsTable from 'components/general/table/Table'
import Label from "components/general/Label"
import DateTime from 'components/presentation/DateTime'
import Competitor from 'components/presentation/Competitor'
import Noc from "components/presentation/Noc";
import { getDateTimeFormat } from 'helpers/utils'
export default function TeamOfficials({ data }) {


  const columns = useMemo(
    () => [
      ColumnFunction(),
      ColumnName(),
      // ColumnBirthDate(),
    ], []);

  return (
    <>
      {data?.team?.teamCoaches &&
        <>
          <a name="officials"><h2 className="wrsBiosDetail__h2" ><Label data="LabelTeamOfficials" /></h2></a>
          < MirsTable
            data={
              data?.team?.teamCoaches?.sort((b, a) => {
                const coachName = a?.coach?.name?.toLowerCase().localeCompare(b?.coach?.name?.toLowerCase());
                const coachOrder = a?.order - b?.order;
                //const coachOrder =  a?.function?.fOrder - b?.function?.fOrder;
                return coachOrder || coachName;
              })
            }
            columns={columns}
            id={`mirs-table-team-officials`}
          />
        </>
      }
    </>
  )
}

function ColumnName() {
  return (
    {
      Header: <Label data="HeaderName" />,
      accessor: 'name',
      className: "text-start'",
      headerClassName: "text-start",
      disableSortBy: true,
      id: 'name',
      Cell: (props) => {
        const coach = props.cell.row.original?.coach;
        let nationality = coach?.nationality?.code;
        let organisation = coach?.organisation?.code;
        let showNationality = false;
        if (nationality !== organisation) {
          showNationality = true;
        }
        return (
          <div className="d-flex">
            <Competitor {...coach} mainFunction={props.cell.row.original?.function} __typename={'Person'} shortName={coach?.name} noLink={coach?.function?.category === 'T'} hideNoc={true} hidePicture={false} key={`participant-${coach?.code}`} />
            {showNationality && <Noc {...coach?.nationality} />}
          </div>
        );
      }
    }
  )
}

function ColumnFunction() {
  return (
    {
      Header: <Label data="HeaderFunction" />,
      className: "text-start'",
      headerClassName: "text-start w-30",
      disableSortBy: true,
      id: 'function',
      Cell: (props) => {
        const row = props.cell.row.original
        return (<>
          <span> {row?.function?.description} </span>
        </>);
      }
    }
  )
}

function ColumnBirthDate() {
  return (
    {
      Header: <Label data="HeaderBirthDate" />,
      accessor: 'birthDate',
      className: "text-start'",
      headerClassName: "text-start w-20",
      disableSortBy: true,
      id: 'birthDate',
      Cell: (props) => {
        const row = props.cell.row.original
        const formatDate = getDateTimeFormat('DayMonthShortYear');
        return (
          <DateTime format={formatDate} datetime={row?.coach?.birthDate} />
        )
      }
    }
  )
}